import { getRideList } from "api/ride";
import CustomReactSelect from "components/CustomReactSelect";
import PropTypes from "prop-types";
import { useCallback, useEffect } from "react";
import useGlobalStore from "store/useGlobalStore";


const RideSelector = ({
    value,
    onChange,
    label = "Ride",
    placeholder = "Select...",
    isMulti = false,
    required = false,
    disabled = false,
    isFilter = false,
    ...props
}) => {
    const { rides, setRides } = useGlobalStore();

    const loadOptions = useCallback(async () => {
        try {
            let dataOptions = rides.length > 0 ? rides : [];

            if (dataOptions.length === 0) {
                const response = await getRideList({ get_all: true });
                const data = response.data?.data ?? [];
                dataOptions = data.map(ride => ({
                    label: ride.name,
                    value: ride.id
                }));
                setRides(dataOptions);
            }

            if (isFilter && !dataOptions.some(option => option.value === "")) {
                dataOptions = [{ label: "All", value: "" }, ...dataOptions];
            }
            return dataOptions;
        } catch (error) {
            return [];
        }
    }, [rides, setRides, isFilter]);

    // Load options on component mount
    useEffect(() => {
        loadOptions();
    }, []);

    const getSelectedValue = () => {
        if (!value && value !== "") return null;

        // Build complete options list including filter option
        let availableOptions = [...rides];
        if (isFilter && !availableOptions.some(option => option.value === "")) {
            availableOptions = [{ label: "All", value: "" }, ...availableOptions];
        }


        if (isMulti) {
            const selected = availableOptions.filter(option => value.includes(option.value));
            return selected.length > 0 ? selected : null;
        }

        const selected = availableOptions.find(option => option.value === value);
        return selected || null;
    };

    const handleChange = (selectedOption) => {
        if (isMulti) {
            const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
            if (onChange) {
                onChange(selectedValues, selectedOption);
            }
        } else {
            const selectedValue = selectedOption ? selectedOption.value : (isFilter ? "" : null);
            if (onChange) {
                onChange(selectedValue, selectedOption);
            }
        }
    };


    return (
        <CustomReactSelect
            async
            label={label}
            isMulti={isMulti}
            isSearchable
            value={getSelectedValue()}
            loadOptions={loadOptions}
            defaultOptions={rides}
            onChange={handleChange}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            noOptionsMessage={() => "No rides found"}
            {...props}
        />
    );
};

RideSelector.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
        PropTypes.string,
        PropTypes.number,
    ]),
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isMulti: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
};

export default RideSelector;
